import { css, cx } from '@linaria/core';
import { FC, useEffect } from 'react';
import { Menu } from '@headlessui/react';
import { useField } from 'formik';
import { useRouter } from 'next/router';
import { breakpoints } from 'styles/utils';
import SvgChevronSelectorVerticalSm from '../Icons/ChevronSelectorVerticalSm';
import ChatModeIcon from '../Icons/ChatModeIcon';
import VisionModeIcon from '../Icons/VisionModeIcon';
import { PlaygroundConfig, PlaygroundScreenType } from '../../types/playgroundConfig';
const SwitchValues: {
  icon: FC;
  text: string;
  value: PlaygroundConfig['type'];
}[] = [{
  icon: ChatModeIcon,
  text: 'Chat',
  value: 'chat'
}, {
  icon: VisionModeIcon,
  text: 'Vision',
  value: 'vision'
}];
export const ModeSwitch: FC = () => {
  const [selectedType,, {
    setValue: setSelectedType
  }] = useField<PlaygroundConfig['type']>('type');
  const router = useRouter();

  // TODO: Remove this after we're sure we don't need the ability to manually switch modes
  const AUTO_SWITCH_ENABLED = false;
  const ActiveType = SwitchValues.find(switchValue => {
    return switchValue.value === selectedType.value;
  }) ?? SwitchValues[0];
  const OtherTypes = SwitchValues.filter(switchValue => switchValue.value !== ActiveType.value);

  // set selected type on first load of the component
  useEffect(() => {
    if (router.isReady && router.query.mode) {
      setSelectedType((router.query.mode as PlaygroundConfig['type']));
    }
  }, [router.isReady]);
  const handleChange = (value: PlaygroundScreenType) => {
    router.push({
      query: {
        ...router.query,
        mode: value
      }
    }, undefined, {
      shallow: true
    }).then(() => {
      setSelectedType(value);
      return true;
    }).catch(() => null);
  };
  return <Menu as="div" className={modeSwitchMenuStyle}>
      <Menu.Button disabled={!AUTO_SWITCH_ENABLED} style={{
      cursor: AUTO_SWITCH_ENABLED ? 'pointer' : 'default'
    }}>
        <div className={modeSwitchContainer}>
          <ActiveType.icon />
          <span className={cx(modeTextStyle, modeTextStyleCTA)}>{ActiveType.text}</span>
          {AUTO_SWITCH_ENABLED ? <SvgChevronSelectorVerticalSm /> : null}
        </div>
      </Menu.Button>
      {AUTO_SWITCH_ENABLED ? <Menu.Items className={modeSwitchMenuOptionsStyle}>
          {OtherTypes.map((EachType, index) => {
        const handleMenuClick = () => handleChange(EachType.value);
        return <Menu.Item onClick={handleMenuClick} as="div" className={modeSwitchOptionStyle} key={index.toString()}>
                {({
            active
          }) => {
            return <div className={cx(modeSwitchContainer, modeSwitchOptionContainer, active ? modeSwitchOptionStyleActive : '')}>
                      <EachType.icon />
                      <span className={modeTextStyle}>{EachType.text}</span>
                    </div>;
          }}
              </Menu.Item>;
      })}
        </Menu.Items> : null}
    </Menu>;
};
const modeSwitchMenuStyle = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchMenuStyle-mtbb678";
const modeSwitchContainer = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchContainer-m1shkpf1";
const modeTextStyle = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeTextStyle-m15xihuy";
const modeTextStyleCTA = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeTextStyleCTA-mdxccdp";
const modeSwitchMenuOptionsStyle = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchMenuOptionsStyle-mnidkcy";
const modeSwitchOptionStyle = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchOptionStyle-m1ndbuan";
const modeSwitchOptionContainer = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchOptionContainer-mc7imkd";
const modeSwitchOptionStyleActive = "odules__Playground__Components__ModeSwitch__ModeSwitch_tsx-modeSwitchOptionStyleActive-m6kjakt";

require("./ModeSwitch.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ModeSwitch.tsx");